module.exports = __webpack_public_path__ + "static/media/sample_home_wireframe.fc047478.png";